import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { Channel } from 'icreate/common/models/channel';
import { Observable, lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ChannelService {
    private domain: string;

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    public getChannels(vesselId: string): Observable<Channel[]> {
        const param = {
            vesselId,
        };
        return this.http.get<Channel[]>(`${this.domain}/api/channels`, {
            params: param,
        });
    }

    public getById(channelId: string) {
        return this.http.get<Channel>(`${this.domain}/api/channel/id/${channelId}`);
    }

    public getByRowId(vesselId, rowId: string) {
        const param = {
            vesselId,
            rowId,
        };
        return lastValueFrom(
            this.http.get<any>(`${this.domain}/api/channel/rowId`, {
                params: param,
            })
        );
    }

    async getChannelsByGroup(vesselId: string, groupId): Promise<Channel[]> {
        const param = {
            vesselId,
        };
        return await lastValueFrom(
            this.http.get<Channel[]>(`${this.domain}/api/channels/${groupId}`, {
                params: param,
            })
        );
    }

    public getChannel(vesselId: string, rowId: string, groupId: string): Observable<Channel> {
        const param = {
            vesselId,
            rowId,
            groupId,
        };
        return this.http.get<Channel>(`${this.domain}/api/channel`, {
            params: param,
        });
    }

    getByFcuChannelId(vesselId, fcuChannelId) {
        const params = {
            vesselId,
            fcuChannelId,
        };
        return lastValueFrom(this.http.get<any>(`${this.domain}/api/channel/fcuChannelId`, { params }));
    }

    public update(channel: Channel): Observable<string> {
        return this.http.put<string>(`${this.domain}/api/ops/channels/${channel.id}`, channel);
    }

    public async updateList(channelList: Channel[]) {
        return await lastValueFrom(this.http.put<string>(`${this.domain}/api/ops/channelList`, channelList));
    }

    public async create(channel: Channel[] | Channel) {
        await lastValueFrom(this.http.post<string>('/api/channel', Array.isArray(channel) ? channel : [channel]));
    }
}
